// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2103":"aa4cee05","4112":"aa4cee05"}[chunkId] + ".chunk.css";
};